import React, { lazy, Suspense } from "react";
import HomePage from "./pages/HomePage";
import DirectoryPage from "./pages/DirectoryPage";
import SchedulePage from "./pages/SchedulePage";
import MainLayout from "./layouts/MainLayout";
import LoginGate from "./LoginGate";

import {
  Route,
  createBrowserRouter,
  createRoutesFromElements,
  RouterProvider,
} from "react-router-dom";

// Load the bundled geography only when someone opens the employee map.
const MapPage = lazy(() => import("./pages/MapPage"));

const router = createBrowserRouter(
  createRoutesFromElements(
    <Route path="/" element={<MainLayout />}>
      <Route index element={<HomePage />} />
      <Route path="/schedule" element={<SchedulePage />} />
      <Route path="/directory" element={<DirectoryPage />} />
      <Route path="/map" element={
        <Suspense fallback={<div role="status">Loading employee map…</div>}>
          <MapPage />
        </Suspense>
      } />
    </Route>
  )
);

function App() {
  return (
    <LoginGate>
      <RouterProvider router={router} />
    </LoginGate>
  );
}

export default App;
